import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo, PropsWithChildren, useMemo } from 'react';
import Image from '../Image';
import RichText from '../RichText';
import { QuoteProps } from './Quote.interface';
import useStyles from './Quote.styles';

const QuoteComponent = ({
  quote,
  person,
  image,
  orientation = 'No Image',
  alignment = 'left',
  theme = Theme.light,
  className: overrideClassName,
  datalayerPosition = '',
}: PropsWithChildren<QuoteProps>) => {
  // const { RichText, Image } = useComponents();
  const classes = useStyles({});

  const shouldDisplayImage = useMemo(
    () => orientation && !/^no image$/i.test(orientation),
    [orientation],
  );

  const rootClassName = clsx(
    classes.root,
    `${theme}-theme`,
    `${orientation.toLowerCase()}-orientation`,
    `${alignment}-alignment`,
    overrideClassName,
  );

  return (
    <div
      className={rootClassName}
      data-testid="qa-quote-component"
      {...(!!datalayerPosition && { 'data-datalayer-position': datalayerPosition })}
    >
      {shouldDisplayImage && image?.original?.url && (
        <div className={classes.image}>
          <Image image={{ ...image, fullWidthImage: true }} type="base" />
        </div>
      )}

      <div className={classes.content}>
        <RichText customStyles theme={theme} content={quote} className={classes.quote} />
        <RichText customStyles theme={theme} content={person} className={classes.person} />
      </div>
    </div>
  );
};

export default memo(QuoteComponent);
